"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSurveyAssetTranslationMappingRequestToJSON = exports.UpdateSurveyAssetTranslationMappingRequestFromJSONTyped = exports.UpdateSurveyAssetTranslationMappingRequestFromJSON = exports.instanceOfUpdateSurveyAssetTranslationMappingRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateSurveyAssetTranslationMappingRequest interface.
 */
function instanceOfUpdateSurveyAssetTranslationMappingRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateSurveyAssetTranslationMappingRequest = instanceOfUpdateSurveyAssetTranslationMappingRequest;
function UpdateSurveyAssetTranslationMappingRequestFromJSON(json) {
    return UpdateSurveyAssetTranslationMappingRequestFromJSONTyped(json, false);
}
exports.UpdateSurveyAssetTranslationMappingRequestFromJSON = UpdateSurveyAssetTranslationMappingRequestFromJSON;
function UpdateSurveyAssetTranslationMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audioAssetId': !(0, runtime_1.exists)(json, 'audio_asset_id') ? undefined : json['audio_asset_id'],
        'logoAssetId': !(0, runtime_1.exists)(json, 'logo_asset_id') ? undefined : json['logo_asset_id'],
        'companionAssetId': !(0, runtime_1.exists)(json, 'companion_asset_id') ? undefined : json['companion_asset_id'],
        'brandName': !(0, runtime_1.exists)(json, 'brand_name') ? undefined : json['brand_name'],
        'transparencyLink': !(0, runtime_1.exists)(json, 'transparency_link') ? undefined : json['transparency_link'],
        'transparencyLinkText': !(0, runtime_1.exists)(json, 'transparency_link_text') ? undefined : json['transparency_link_text'],
    };
}
exports.UpdateSurveyAssetTranslationMappingRequestFromJSONTyped = UpdateSurveyAssetTranslationMappingRequestFromJSONTyped;
function UpdateSurveyAssetTranslationMappingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audio_asset_id': value.audioAssetId,
        'logo_asset_id': value.logoAssetId,
        'companion_asset_id': value.companionAssetId,
        'brand_name': value.brandName,
        'transparency_link': value.transparencyLink,
        'transparency_link_text': value.transparencyLinkText,
    };
}
exports.UpdateSurveyAssetTranslationMappingRequestToJSON = UpdateSurveyAssetTranslationMappingRequestToJSON;
